'use client';

import type { ReactNode } from 'react';
import { cn } from '@ecom/helper-react-class-combine';
import { useUser } from '@/features/auth/shared/hooks/use-user';
import { showsMemberDashboard } from '@/features/membership/internal/helper/shows-member-dashboard';

export function MembershipUpsellGate({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { loading, authenticatedUser } = useUser();

  if (showsMemberDashboard(authenticatedUser?.membershipDetails)) return null;

  const isSessionUnknown = loading && !authenticatedUser;
  return (
    <div
      className={cn(
        className,
        'transition-opacity duration-300',
        isSessionUnknown && 'invisible opacity-0',
      )}
    >
      {children}
    </div>
  );
}
